import { useTokenStore } from '../store/token'
import { useGlobalStore } from '../store/global'


// Check if token is present, if not login and store token
export default async function (to, from) {  

  const tokenStore = useTokenStore();
  const globalStore = useGlobalStore();
  const nuxtApp = useNuxtApp()

  if (to.path == "/auth/login" || to.path == "/auth/grant") {
    return
  }

  let array_token = to.path ? to.path.split("access_token=") : []
  if (array_token.length == 2) {
    console.log("authenticate with", array_token[1]);

    const { data: login } = await useFetch('/authentication', {
      method: 'POST',
      baseURL: globalStore.apiBase,
      body: {
        strategy: "jwt",
        accessToken: array_token[1]
      },
      //pick: ['accessToken']
    });
    //updateAppConfig({public: {bearerAuth: login.value.accessToken}});
    if (login.value && login.value.accessToken) {
      sessionStorage.setItem("myquote-login", JSON.stringify(login.value));
      tokenStore.updateToken(login.value.accessToken);
      await globalStore.updateUser(login.value.user);

      if ( login.value.user.email!="julien.blanchard@ext.hermes.com" && !nuxtApp.$isUserRoleGreaterThan("sales_associate_front")) {
        console.log("authenticated but wrong role", login.value.user);
        return navigateTo("/auth/grant")
      } else {
        console.log("authenticated", login.value.user.email);
        return navigateTo("/")
      }

    } else {
      return navigateTo("/auth/login")
    }
  }

  var login = sessionStorage.getItem("myquote-login")
  login = login ? JSON.parse(login) : null




  if (login && login.accessToken && login.authentication.payload.exp > (Date.now() * 0.001 - 100)) {
    if (!login.user.role) {
      console.log("authenticated but wrong role");
      return navigateTo("/auth/grant")
    }
    if (tokenStore.currentValue == "") {
      console.log("update token ...")
      tokenStore.updateToken(login.accessToken);
      await globalStore.updateUser(login.user);
    }
  } else {
    console.log("token expiré")
    return navigateTo("/auth/login")
  }



  return;
}
